import React from "react";

function Contact() {
  return (
    <section id="contact" className="container mt-5 mb-5">
      <h2 className="section-title"></h2>
      <div className="contact-card">
        <p className="contact-sub">Have a project in mind or just want to say hi?</p>
        <a className="contact-email" href="mailto:tanudeol90@gmail.com">
          tanudeol90@gmail.com
        </a>
        <div className="hero-socials mt-3">
          <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-linkedin"></i>
          </a>
          <a href="https://github.com/tanveer-deol" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-github"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;